module.exports = __webpack_public_path__ + "static/media/texture (5).f20246e7.jpg";